/**
 * Validates a `returnTo` query-param value to prevent open-redirect attacks.
 * Only relative paths starting with `/` (but not `//`) are allowed.
 * Returns `fallback` for anything else (absolute URLs, protocol-relative, etc.).
 */
export function safeReturnTo(value: string | null | undefined, fallback = '/'): string {
  if (!value) return fallback
  if (value.startsWith('/') && !value.startsWith('//')) return value
  return fallback
}
